// extracted by mini-css-extract-plugin
module.exports = {"emptyList":"EmptyPage_emptyList__3gbF8","emptyPage":"EmptyPage_emptyPage__VAwVL"};